<template>
  <page-loader>
    <v-container>
      <v-row no-gutters>
        <v-col class="d-flex align-center">
          <autocomplete-input
            v-model="selectedOffer"
            :items="mappedOffers"
            class="mr-4"
            label="Offers"
            no-data-text="No offers found"
            hide-details
          />

          <v-spacer />

          <autocomplete-input
            v-for="option in filterOptions"
            :key="option.name"
            v-model="query.params[option.model]"
            :clearable="option.clearable"
            :items="getItemsForOption(option.dataKey)"
            :label="option.name"
            class="ml-4"
            hide-details
          />
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-row>
        <v-col>
          <template v-if="selectedOffer">
            <v-card outlined>
              <v-card-text>
                <div class="d-flex align-center">
                  <v-chip color="grey lighten-4">
                    <v-icon class="mr-2">link</v-icon>
                    {{ visitLinkUrl }}
                  </v-chip>
                  <v-spacer />
                  <v-btn color="primary" depressed @click="copy(visitLinkUrl, 'Visit Link')">
                    <v-icon left small>file_copy</v-icon>
                    Copy Link
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
            <v-card class="mt-4" outlined>
              <v-card-text>
                <div class="d-flex align-center">
                  <v-chip color="grey lighten-4">
                    <v-icon class="mr-2">link</v-icon>
                    {{ shortcode }}
                  </v-chip>
                  <v-spacer />
                  <text-input v-model="buttonText" label="Button text" hide-details outlined />
                  <v-btn class="ml-2" color="primary" depressed @click="copy(shortcode, 'Visit Shortcode')">
                    <v-icon left small>file_copy</v-icon>
                    Copy Shortcode
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
          </template>
          <v-alert v-else class="mb-0" type="info" border="left">
            Please select an offer to generate a visit link
          </v-alert>
        </v-col>
      </v-row>
    </v-container>
  </page-loader>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

import AutocompleteInput from '@/components/forms/autocomplete-input'
import PageLoader from '@/components/page-loader'
import TextInput from '@/components/forms/text-input'

import QueryParamsHandler from '@/mixins/query-params-handler'

import { offers } from '@/services/offers'

export default {
  name: 'VisitLinks',
  components: {
    AutocompleteInput,
    PageLoader,
    TextInput,
  },
  mixins: [QueryParamsHandler],
  data: () => ({
    buttonText: '',
    selectedOffer: '',
    offers: [],
    filterOptions: [
      {
        name: 'Offer Type',
        clearable: false,
        dataKey: 'offerTypes',
        model: 'offerType',
      },
    ],
    queriesDefined: ['offerType'],
    queryDefaults: ['offerType'],
  }),
  computed: {
    ...mapGetters('options', ['getItemsForOption']),
    visitLinkUrl() {
      return `/visit/${this.selectedOffer}`
    },
    shortcode() {
      return `[inv-visit offer="${this.selectedOffer}"]${this.buttonText}[/inv-visit]`
    },
    mappedOffers() {
      return this.offers.map(({ name, slug }) => ({ key: name || slug, value: slug }))
    },
  },
  watch: {
    'query.params.offerType': {
      handler() {
        this.selectedOffer = ''
      },
    },
  },
  methods: {
    ...mapActions('options', ['getOptions']),
    ...mapMutations('general', ['setPageLoading', 'setPageErrors']),
    copy(val, text) {
      this.copyToClipboard(val, text)
    },
    copyToClipboard(text, label) {
      const textArea = document.createElement('textarea')
      textArea.value = text
      textArea.style.position = 'absolute'
      textArea.style.top = '-100000px'
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()

      try {
        document.execCommand('copy')
        this.$notify({
          text: `${label} has been copied to your clipboard.`,
        })
      } catch (err) {
        this.$notify({
          type: 'error',
          text: `Unable to copy ${label}`,
        })
      }

      document.body.removeChild(textArea)
    },
    async getOffers() {
      this.isLoading = true

      try {
        const { data } = await offers.getAllOffers({ compact: true, filters: this.queryFilters })
        this.offers = data
      } catch (error) {
        this.setPageErrors(true)
        this.$notify({
          type: 'error',
          text: 'Unable to retrieve Offers',
        })
      }

      this.setPageLoading(false)
      this.isLoading = false
    },
    async handleQueryUpdate() {
      await this.getOffers()
    },
  },
}
</script>
